import { Info } from "lucide-react";
import { isSupabaseConfigured } from "@/lib/env";

/** Shown while the backend/integrations are not wired - the data is mock. */
export function DemoBanner({ detail }: { detail?: string }) {
  if (isSupabaseConfigured) return null;
  return (
    <div className="mb-6 flex min-w-0 items-start gap-2 rounded-md border border-amber-200 bg-amber-50 p-3 text-sm text-amber-800">
      <Info className="mt-0.5 h-4 w-4 shrink-0" />
      <span className="min-w-0 break-words">
        Preview mode - showing mock data. Live Fleetio units appear after you create a{" "}
        <code className="break-all rounded bg-amber-100 px-1">.env</code> with{" "}
        <code className="break-all rounded bg-amber-100 px-1">VITE_SUPABASE_URL</code> and{" "}
        <code className="break-all rounded bg-amber-100 px-1">VITE_SUPABASE_ANON_KEY</code>, deploy
        the <code className="break-all rounded bg-amber-100 px-1">fleet</code> edge function with
        Fleetio secrets, and sign in as staff. See{" "}
        <code className="break-all rounded bg-amber-100 px-1">docs/FLEETIO-SETUP.md</code>.
        {detail ? ` ${detail}` : ""}
      </span>
    </div>
  );
}
